import { FC, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';

import { Spinner } from 'dibs-elements/exports/Spinner';
import { Button } from 'dibs-elements/exports/Button';

import styles from '../styles/Spinner.scss';
import dibsCss from 'dibs-css';

type Props = {
    isLoading: boolean;
    onSubmit: () => void;
    submitCopy?: ReactNode;
    disabled?: boolean;
};

const FormButton: FC<Props> = ({
    isLoading,
    onSubmit,
    submitCopy = (
        <FormattedMessage defaultMessage="Continue" id="SellerApplicationForm.formButton" />
    ),
    disabled = false,
}) => {
    return (
        <Button
            onClick={onSubmit}
            className={classnames(dibsCss.mtXsmall, dibsCss.mbSmall, dibsCss.wFull)}
            disabled={isLoading || disabled}
        >
            {!isLoading ? (
                submitCopy
            ) : (
                <div
                    className={classnames(
                        dibsCss.flex,
                        dibsCss.wFull,
                        dibsCss.justifyCenter,
                        dibsCss.itemsCenter
                    )}
                >
                    <Spinner dark containerClass={styles.spinner} size="tiny" />
                    <FormattedMessage
                        defaultMessage="Saving..."
                        id="SellerApplicationForm.formButton.saving"
                    />
                </div>
            )}
        </Button>
    );
};

export default FormButton;
